export const Fonts = {
  base: '"Poppins", sans-serif',
  secondary: '"Archia", sans-serif',
};
